import {css} from "@panda/css";

import {VideoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {DetailSectionWrapper} from "../../atoms/DetailSectionWrapper";

interface IProps {
    url: string;
    videoTitle?: string;
}

export const OfferVideo = ({url, videoTitle}: IProps) => {
    return (
        <DetailSectionWrapper>
            <div className={iconWrapper}>
                <VideoIcon wrapperColor="var(--colors-primary)" size="6.4" wrapperSize="6.4" />
                <Text variant="headline_2" align="center">
                    Zobacz video z inwestycji
                </Text>
            </div>

            <div className={videoWrapper}>
                <iframe
                    className={iframeStyle}
                    src={url}
                    title={`Wideo: ${videoTitle || "Prezentacja inwestycji"}`}
                    allow="encrypted-media"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </DetailSectionWrapper>
    );
};

const iconWrapper = css({
    display: "flex",
    gap: 2,
    alignItems: "center",
    flexDirection: "column",
    marginBottom: 3,

    sm: {
        flexDirection: "row"
    }
});

const videoWrapper = css({
    position: "relative",
    width: "100%",
    height: "auto",

    "@supports (aspect-ratio: 16 / 9)": {
        aspectRatio: "16 / 9",
        height: "auto",
        paddingBottom: "0"
    },

    "@supports not (aspect-ratio: 16 / 9)": {
        height: "0",
        paddingBottom: "56.25%"
    }
});

const iframeStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none"
});
import {css} from "@panda/css";

import {VideoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {DetailSectionWrapper} from "../../atoms/DetailSectionWrapper";

interface IProps {
    url: string;
    videoTitle?: string;
}

export const OfferVideo = ({url, videoTitle}: IProps) => {
    return (
        <DetailSectionWrapper>
            <div className={iconWrapper}>
                <VideoIcon wrapperColor="var(--colors-primary)" size="6.4" wrapperSize="6.4" />
                <Text variant="headline_2" align="center">
                    Zobacz video z inwestycji
                </Text>
            </div>

            <div className={videoWrapper}>
                <iframe
                    className={iframeStyle}
                    src={url}
                    title={`Wideo: ${videoTitle || "Prezentacja inwestycji"}`}
                    allow="encrypted-media"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </DetailSectionWrapper>
    );
};

const iconWrapper = css({
    display: "flex",
    gap: 2,
    alignItems: "center",
    flexDirection: "column",
    marginBottom: 3,

    sm: {
        flexDirection: "row"
    }
});

const videoWrapper = css({
    position: "relative",
    width: "100%",
    height: "auto",

    "@supports (aspect-ratio: 16 / 9)": {
        aspectRatio: "16 / 9",
        height: "auto",
        paddingBottom: "0"
    },

    "@supports not (aspect-ratio: 16 / 9)": {
        height: "0",
        paddingBottom: "56.25%"
    }
});

const iframeStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none"
});
